<template>
  <LoadingWithSlot
    :is-loading="isLoading || isFetching"
    :height="400"
  >
    <div class="defi-summary-container">
      <div class="flex flex-col justify-between gap-y-2 p-4">
        <EpCountCard
          label="Total Value Locked"
          :value="data?.formattedTvl"
          value-prefix="$"
          direction="horizontal"
        >
          <template #below>
            <PercentTag
              :value="data?.tvlChange"
              class="text-xs leading-6"
            />
          </template>
        </EpCountCard>
        <TvlMetricTable
          :columns="data?.metricInfo.headers"
          :rows="data?.metricInfo.items"
          class="tvl-metric-table"
          vertical
        >
          <template #item-week="{row}">
            <PercentTag :value="row.original.week" />
          </template>
          <template #item-month="{row}">
            <PercentTag :value="row.original.month" />
          </template>
          <template #item-half="{row}">
            <PercentTag :value="row.original.half" />
          </template>
        </TvlMetricTable>

        <EpCountCard
          :label="`${UNIT} Price`"
          :value="data?.formattedPrice"
          value-prefix="$"
          direction="horizontal"
        >
          <template #below>
            <PercentTag
              :value="data?.priceChange"
              class="text-xs leading-6"
            />
          </template>
        </EpCountCard>
      </div>
      <Divider class="hidden mobile:block" />
      <TvlChart
        :data="data"
        :is-loading="isLoading || isFetching"
        v-model:period="period"
      />
    </div>
  </LoadingWithSlot>
</template>
<script setup lang="ts">
import { useGetDefiChartList } from '~/api/service/ecosystem.service'
import TvlChart from '~/components/@pages/defi-dashboard/DefiTvlChart.vue'
import EpCountCard from '~/components/card/EpCountCard.vue'
import CommonTable from '~/components/table/CommonTable.vue'
import PercentTag from '~/components/tag/PercentTag.vue'
import { UNIT } from '~/constants/default.constants'
import type { MetricTableData } from '~/types/defi.type'
import { chartPeriodType } from '~/types/period.type'

const period = ref<chartPeriodType>(chartPeriodType.DAILY)
const { data, isLoading, isFetching } = useGetDefiChartList()

const TvlMetricTable = CommonTable<MetricTableData>
</script>

<style scoped lang="scss">
.defi-summary-container {
  @apply grid gap-x-4 grid-cols-[auto_1fr] mobile:grid-cols-1;
}

.tvl-metric-table {
  @apply bg-default/5 p-2 font-bold;
  :deep(tr:has(th)) {
    @apply border-r border-white/10 pr-1;
  }

  :deep(th), :deep(td) {
    @apply p-2;
  }
}
</style>